import { LazyLoader } from '@bp/ui-components';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../components/Page/Page';
import { PublishedSubstitutionsTable } from '../../../components/PublishedSubstitutions/tables/PublishedSubstitutionsTable';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SubstitutionsSubpage = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageAdministration()} title={t('routes.substitutions.title')}>
      <Suspense fallback={<LazyLoader transparent forceHeight='50vh' fullWidth size='xxl' />}>
        <PublishedSubstitutionsTable />
      </Suspense>
    </Page>
  );
};
